import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Collapse from 'bootstrap/js/dist/collapse';
import ScrollSpy from 'bootstrap/js/dist/scrollspy';

class Navbar extends React.Component {
  componentDidMount() {
    const nav = document.querySelector("nav");
    const navHeight = nav ? nav.offsetHeight : 0;

    document.querySelectorAll('a.js-scroll[href*="#"]:not([href="#"])').forEach(anchor => {
      anchor.addEventListener("click", (event) => {
        event.preventDefault();
        const href = anchor.getAttribute("href");
        if (href) {
          const targetId = href.substring(1);
          const target = document.getElementById(targetId);
          if (target) {
            window.scrollTo({
              top: target.offsetTop - navHeight + 5,
              behavior: "smooth"
            });
          }
        }
      });
    });

    window.addEventListener("scroll", () => {
      const navbar = document.querySelector(".navbar");
      if (navbar) {
        if (window.pageYOffset > 50) {
          navbar.classList.add("navbar-reduce");
          navbar.classList.remove("navbar-trans");
        } else {
          navbar.classList.add("navbar-trans");
          navbar.classList.remove("navbar-reduce");
        }
      }
    });

    const body = document.body;
    if (body) {
      body.setAttribute("data-bs-spy", "scroll");
      body.setAttribute("data-bs-target", "#mainNav");
      body.setAttribute("data-bs-offset", navHeight.toString());
      body.classList.add("scrollspy-example");
      new ScrollSpy(body, {
        target: '#mainNav',
        offset: navHeight
      });
    }

    // Initialize Collapse
    const navbarCollapse = document.getElementById('navbarDefault');
    if (navbarCollapse) {
      new Collapse(navbarCollapse, {
        toggle: false
      });
    }
  }

  render() {
    return (
      <nav
        className="navbar navbar-b navbar-trans navbar-expand-md fixed-top"
        id="mainNav"
      >
        <div className="container d-flex justify-content-between">
          <a className="navbar-brand js-scroll" href="#home">
            Sophie Sude Fidan
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarDefault"
            aria-controls="navbarDefault"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-end" id="navbarDefault">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a className="nav-link js-scroll active" href="#home">
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link js-scroll" href="#projects">
                  Projects
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link js-scroll" href="#career">
                  Career
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link js-scroll" href="#skills">
                  Skills
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link js-scroll" href="#achievements">
                  Achievements
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link js-scroll" href="#contact">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;